import React from 'react';
import { useTranslation } from 'react-i18next';
import Immutable from 'immutable';
import { useSelector } from 'react-redux';

import {
  Container,
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';

import { DEFAULT_LANGUAGE } from '../../../config/constants';

import './style.scss';

const CampaignNavigation = ({ slogan }) => {
  const { t } = useTranslation();

  const previousRouteUrl = useSelector((state) => state.getIn(['uiInternal', 'previousUrl', 'location', 'pathname'], null));
  const chainApproachTerms = useSelector((state) => state.getIn(['uiInternal', 'vocabularies', 'chainapproach'], Immutable.List()));
  const activeChainApproachTerm = chainApproachTerms.find((chainApproachTerm) => {
    const langcode = chainApproachTerm.getIn(['langcode', 0, 'value'], DEFAULT_LANGUAGE);
    return chainApproachTerm.getIn(['paths', langcode]) === previousRouteUrl;
  });

  const name = activeChainApproachTerm ? activeChainApproachTerm.getIn(['name', 0, 'value']) : null;
  let url = null;
  if (activeChainApproachTerm) {
    const langcode = activeChainApproachTerm.getIn(['langcode', 0, 'value'], DEFAULT_LANGUAGE);
    url = activeChainApproachTerm.getIn(['paths', langcode]);
  }

  return (
    <>
      {activeChainApproachTerm && (
        <div className="CampaignNavigation">
          <Container>
            <div className="CampaignNavigation__wrapper">
              <Button
                className="Button Button--ghost"
                href={url}
              >
                <i className="icon icon-after icon-arrow-left icon-variant-2" />
                {t('general.back_to')} {name.toLowerCase()}
              </Button>
              <div className="CampaignNavigation__text">
                {slogan}
              </div>
            </div>
          </Container>
        </div>
      )}
    </>
  );
};

export default CampaignNavigation;


